export default __webpack_public_path__ + "static/home-hero-mobile-d50a60d9538629282fed225c94dccae8.png";